import type { PlayerPosition, ProximityConfig } from '../types';

/**
 * Calculate 3D Euclidean distance between two positions
 */
export function calculateDistance(
  pos1: PlayerPosition,
  pos2: PlayerPosition
): number {
  const dx = pos2.x - pos1.x;
  const dy = pos2.y - pos1.y;
  const dz = pos2.z - pos1.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

/**
 * Calculate volume based on distance using linear falloff
 * 
 * @param distance - Distance in blocks
 * @param config - Proximity configuration
 * @returns Volume from 0.0 to 1.0
 */
export function calculateVolume(
  distance: number,
  config: ProximityConfig
): number {
  const { maxRange, fadeStartRange } = config;

  // Within fade start range: full volume
  if (distance <= fadeStartRange) {
    return 1.0;
  }

  // Beyond max range: no audio
  if (distance >= maxRange) {
    return 0.0;
  }

  // Linear falloff between fadeStartRange and maxRange
  const fadeRange = maxRange - fadeStartRange;
  const fadeDistance = distance - fadeStartRange;
  return 1.0 - (fadeDistance / fadeRange);
}

/**
 * Default proximity configuration matching server defaults
 */
export const DEFAULT_PROXIMITY_CONFIG: ProximityConfig = {
  maxRange: 32.0,
  fadeStartRange: 16.0,
};
